import { Monitor, Mic, Wifi, Settings, Users, Zap, Camera, HdmiPort, Usb } from "lucide-react";

const RXTKeyFeatures = () => {
  const keyFeatures = [
    {
      icon: <Monitor className="h-8 w-8 text-[#069E50]" />,
      title: "4\" & 6\" Desktop Touch Panels",
      description: "Choose between 4-inch (720×720) and 6-inch (1440×720) displays, both with 160° viewing angles for optimal visibility from any position"
    },
    {
      icon: <Mic className="h-8 w-8 text-[#069E50]" />,
      title: "Dante™/AES67 Audio",
      description: "All models feature Dante™ audio networking with SmartSpeak™ beamforming microphones, advanced feedback suppression, auto gain, noise cancellation, and WordGate™ camera tracking"
    },
    {
      icon: <Settings className="h-8 w-8 text-[#069E50]" />,
      title: "ReAX™ Control System",
      description: "Fully customizable JavaScript-based control platform with unlimited capabilities, 2D/3D graphics engine, and H.264 streaming decoder across all models"
    },
    {
      icon: <Camera className="h-8 w-8 text-[#069E50]" />,
      title: "RTSP Camera Streams",
      description: "All models can capture, display and control RTSP camera streams directly on the panel — even without the VPX AVoIP engine"
    },
    {
      icon: <HdmiPort className="h-8 w-8 text-[#069E50]" />,
      title: "Content Input & Distribution (DV)",
      description: "DV models add USB-C and Mini-HDMI inputs with integrated VPX 1Gbps 4K60 AV over IP for seamless content distribution"
    },
    {
      icon: <Usb className="h-8 w-8 text-[#069E50]" />,
      title: "USB-C 100W Charging (DV)",
      description: "DV models provide USB-C power pass-through with 100-watt charging, USB-C display output, and comprehensive device connectivity"
    },
    {
      icon: <Wifi className="h-8 w-8 text-[#069E50]" />,
      title: "Wireless Remote Control",
      description: "Internal web server on all models enables control from smartphones, computers, and other remote devices"
    },
    {
      icon: <Users className="h-8 w-8 text-[#069E50]" />,
      title: "Meeting Enhancement",
      description: "Voting, room booking, name placeholder, raise hand function, and assistive hearing capabilities across the entire range"
    },
    {
      icon: <Zap className="h-8 w-8 text-[#069E50]" />,
      title: "All-in-One Solution",
      description: "Combines touch control, audio processing, video management, and room automation in a single compact device — choose the model that fits your needs"
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Key Features Across the Range</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {keyFeatures.map((feature, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border shadow-sm">
            <div className="mb-4">{feature.icon}</div>
            <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
            <p className="text-muted-foreground">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RXTKeyFeatures;
